import * as THREE from 'three';
import { PLANET_R } from '../config.js';

// Analytical surface height at a given unit direction on the planet. Shared
// between the mesh's vertex displacement and the character/camera positioning
// so they stay flush with the curve.
export function surfaceHeight(n) {
  return (Math.sin(n.x * 3.1) + Math.cos(n.y * 3.7) + Math.sin(n.z * 4.3)) * 0.12
       + (Math.sin(n.x * 9)   + Math.cos(n.z * 11))                         * 0.04;
}

export function surfaceRadius(n) {
  return PLANET_R + surfaceHeight(n);
}

// Creates the planet mesh: a displaced icosahedron with flat-shaded low-poly
// look. The caller is responsible for adding it to the scene.
export function createPlanet() {
  const geometry = new THREE.IcosahedronGeometry(PLANET_R, 7);
  const pos = geometry.attributes.position;
  const v = new THREE.Vector3();
  for (let i = 0; i < pos.count; i++) {
    v.fromBufferAttribute(pos, i);
    const n = v.clone().normalize();
    v.addScaledVector(n, surfaceHeight(n));
    pos.setXYZ(i, v.x, v.y, v.z);
  }
  geometry.computeVertexNormals();

  const material = new THREE.MeshStandardMaterial({
    color: 0x3d7a28,
    roughness: 0.95,
    flatShading: true,
  });

  const mesh = new THREE.Mesh(geometry, material);
  mesh.receiveShadow = true;
  mesh.castShadow = true;
  return mesh;
}
